import { Dropdown, DropdownItem, DropdownList, Input } from '@cokitchen/cokitchen-components';
import { ArrowDownIcon } from 'cokitchen-icons';
import useDashboardContext from 'contexts/dashboard.context';
import { CoKitchenType } from 'models/cokitchen.model';
import React, { Fragment } from 'react';
import { STORAGE_KEYS } from 'utils/constants';

const CokitchenDropdown = () => {
  const cokitchenList = localStorage.getItem(STORAGE_KEYS.COKITCHEN_LIST);

  const cokitchenArray: CoKitchenType[] =
    cokitchenList === 'undefined' ? [] : JSON.parse(cokitchenList || '[]');
  const { activeCokitchen, setActiveCokitchen } = useDashboardContext();

  const handleKitchenChange = (kitchen: CoKitchenType) => {
    setActiveCokitchen(kitchen);
    localStorage.setItem(STORAGE_KEYS.COKITCHEN, kitchen.id);
    window.location.reload();
  };

  return (
    <Fragment>
      {Object.keys(activeCokitchen).length > 0 ? (
        <Dropdown
          content={
            <div className='flex gap-x-2 items-center cursor-pointer'>
              <div className='px-3 py-[6px] inline-flex gap-1 items-center text-sm font-medium rounded-[20px] border border-gray-9'>
                {activeCokitchen?.name}

                <ArrowDownIcon />
              </div>
            </div>
          }>
          <DropdownList className='max-h-[300px] min-w-[200px]'>
            {cokitchenArray.length === 0 || !Array.isArray(cokitchenArray) ? (
              <div></div>
            ) : (
              cokitchenArray.map((p, i) => (
                <DropdownItem key={i} onClick={() => handleKitchenChange(p)}>
                  <Input
                    type='radio'
                    checked={activeCokitchen?.id === p.id}
                    readOnly
                    label={p.name}
                  />
                </DropdownItem>
              ))
            )}
          </DropdownList>
        </Dropdown>
      ) : (
        <div className='px-3 py-[6px] inline-flex gap-1 items-center text-sm font-medium rounded-[20px]'>
          <p>Loading ...</p>
        </div>
      )}
    </Fragment>
  );
};

export default CokitchenDropdown;
